<template>
  <div class="certificate-detail-view">
    <section class="section dynamic-height" ref="form">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="sticky-top" :class="hasShadow">
            <title-component :size="1">
              <translate>Show certificate</translate>
              <status-component
                v-if="certificate.id"
                class="is-pulled-right state"
                :level="certificate.state.level"
                :display="certificate.state.display">
              </status-component>
            </title-component>
          </div>
          <br>
          <div class="scrollable-content">
            <message-component
              v-if="certificate.hasComment"
              :level="certificate.comment.state.displayLevel">
              {{ certificate.comment.text }}
            </message-component>
            <title-component
              :size="2"
              :lineSeparator="'under'">
              <translate>Certificate</translate>
            </title-component>
            <grid-details-component
              v-if="certificate.id"
              :display_spec="certificateSpecs"
              :item="certificate"
              :item_keys="certificate_keys"
              :layoutClasses="getLayoutClasses()">
            </grid-details-component>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import { certificateSpecs } from '@/display_context/display_context'
  import TitleComponent from '@/components/layout/TitleComponent'
  import GridDetailsComponent from '@/components/layout/grid/GridDetailsComponent'
  import StatusComponent from '@/components/layout/utility/StatusComponent.vue'
  import { itemRefresher, setPageHeightMixin } from '@/mixins/mixins'
  import { Certificate } from '@/classes/certificate/Certificate'
  import MessageComponent from '@/components/layout/utility/MessageComponent'
  import { assignLayoutClasses } from '@/utility/utility_functions'

  export default {
    name: 'certificate-detail-view',
    mixins: [setPageHeightMixin, itemRefresher],
    components: {
      GridDetailsComponent,
      TitleComponent,
      StatusComponent,
      MessageComponent
    },
    data () {
      return {
        certificate_keys: ['certificateNumber', 'service.name', 'qualification.value', 'issueDate', 'expiryDate', 'customer.fullName', 'customer.phoneNumber', 'customer.mobileNumber', 'customer.email', 'customer.postalAddress', 'customer.city', 'customer.invoiceCustomerName', 'customer.commune'],
        certificateSpecs: certificateSpecs,
        setAction: this.setCertificate,
        actions: [],
        certificate: {},
        Certificate: Certificate
      }
    },
    props: {
      certificateId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        certificates: state => state.certificateModule.certificates
      })
    },
    methods: {
      ...mapActions([
        'setCertificate'
      ]),
      getLayoutClasses () {
        let values = {
          'default': 'is-6-mobile is-4-tablet is-4-desktop'
        }
        return assignLayoutClasses(values, this.certificate_keys.length)
      },
      switchCertificateKeys () {
        if (this.certificate.customer.hasAdditionalCommunes) {
          if (!this.certificate_keys.includes('customer.communes')) {
            this.certificate_keys.push('customer.communes')
          }
        }
      }
    },
    created () {
      let callbacks = [this.switchCertificateKeys]
      this.setOrRefreshItem('certificate', this.certificates, this.certificateId, callbacks)
    }
  }
</script>

<style lang="sass" scoped>
  .main-view
    min-height: auto

  .state
    margin-top: 2px
    margin-right: 25px

  .certificate, .decision-letter
    width: 100%

  iframe
    min-height: 880px

  .reports-table thead th:nth-child(3)
    display: inline-block
    width: 50%
    background: orange
</style>
